import {
  addAdministrationDetailsAPI,
  deleteAdministrationDetailsAPI,
  getAdministrationDetailsAPI,
  updateAdministrationDetailsAPI,
} from "./api";

export const addAdministrationDetails = (id, data) => {
  return new Promise((resolve, reject) => {
    addAdministrationDetailsAPI(id, data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


export const updateAdministrationDetails = (data) => {
  return new Promise((resolve, reject) => {
    updateAdministrationDetailsAPI(data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getAdministrationDetails = (data) => {
  return new Promise((resolve, reject) => {
    getAdministrationDetailsAPI(data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const deleteAdministrationDetails = (data) => {
  return new Promise((resolve, reject) => {
    deleteAdministrationDetailsAPI(data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};